import { Grid } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { randomFromRange } from 'common/tools/random';
import { BodyType } from 'graphql/generated';
import hero from 'images/car-hero2.png';
import _ from 'react';
import WsFlexbox from 'stories/layout/WsFlexbox';

import HomeSearch from './HomeSearch';
import RecentListings from './RecentListings';

const colorPop = '#FFB300';

const getImage = () => {
  return `ads/ad${randomFromRange(1, 22)}.png`;
};

const Home = () => {
  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          backgroundImage: `url(${hero})`,
          backgroundSize: '100%',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top center',
          minHeight: '250px',
          width: '100%',
          top: '-24px',
        }}
      >
        <WsFlexbox
          sx={{
            textAlign: 'center',
            width: 360,
            alignItems: 'start',
            justifyContent: 'center',
            marginTop: 5,
            marginLeft: 4,
          }}
        >
          <Typography sx={{ color: 'white', fontWeight: 600 }} variant="h3">
            Buy and Sell Direct with&nbsp;
            <Box
              component="span"
              sx={{
                borderBottomStyle: 'solid',
                borderBottomColor: '#FFB300',
                borderBottomWidth: 4,
              }}
            >
              Confidence
            </Box>
          </Typography>
        </WsFlexbox>
        <WsFlexbox sx={{ justifyContent: 'center' }}>
          <HomeSearch sx={{ marginTop: '80px' }} />
        </WsFlexbox>
      </Box>
      <Box>
        <WsFlexbox sx={{ justifyContent: 'center' }}>
          <Box style={{ height: '60%', width: '60%' }}>
            <img style={{ height: '100%', width: '100%' }} src={getImage()} alt="ad" />
          </Box>
        </WsFlexbox>
        <Box pt={1} sx={{ display: 'flex', justifyContent: 'center' }}>
          <Box sx={{ width: '70%' }}>
            <Typography variant="h6" color="primary">
              Recent Listings
            </Typography>
            <RecentListings />
          </Box>
        </Box>
        <Grid mt={4} container>
          <Grid item xs={2}></Grid>
          <Grid item xs={8}></Grid>
          <Grid item xs={2}></Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Home;
